const scormNavigationBarTemplate = ({isPrimaryButton, completeSessionButtonLabel}) => `<div class="scorm-navigation-bar">
   <h1 class="scorm-module-title"></h1>
   <button class="button ${isPrimaryButton ? 'button-primary' : 'button-secondary'} complete-scorm-session-button">${completeSessionButtonLabel}</button>
</div>`;

export default scormNavigationBarTemplate;
